import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Components

import SecureInboxSummary from './subComponents/SecureInboxSummary';
import NonIndSideNav from '../navigation/NonIndSideNavigation';

// Constants

import { configs } from '@constants/configs/configs';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';


const SecureInbox = props => {

    const [emailShown, setEmailShown] = useState(null);
    const [query, setQuery] = useState('');

    const {
        environment: {
            impersonation,
            impersonationDetails,
            links: {
                DASHBOARD
            },
            user: {
                role
            }
        }
    } = props;

    const {
        routes
    } = configs;

    const {
        INDIVIDUAL
    } = ALL_USER_ROLES;

    const useAnchor = (impersonation && impersonationDetails.role !== INDIVIDUAL) || !impersonation;
    const isDelegationPage = props.location &&  props.location.pathname === routes.DELEGATION_CONSUMER;

    
    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="individual-portal">
            <div className="grid-container gi-grid-container">
                <div className={`grid-row grid-gap gi-wrapper ${isDelegationPage && 'gi-wrapper-delegations'}`}>
                    <aside className="desktop:grid-col-3" id="side-nav">

                        <span className="grid-row back-to-dashboard">
                            {
                                useAnchor ?

                                    <a className="gi-button gi-button__subtle-primary border-link" href={DASHBOARD}>
                                        <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link" />
                                        <FormattedMessage id="dashboard.back.link" />
                                    </a>

                                    :

                                    <Link className="gi-button gi-button__subtle-primary" to={routes.INDPORTAL}>
                                        <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link" />
                                        <FormattedMessage id="dashboard.back.link" />
                                    </Link>
                            }
                        </span>

                        <NonIndSideNav {...{ setEmailShown, query, setQuery }} />

                    </aside>

                    <div className="desktop:grid-col-9" id="main-content">
                        <SecureInboxSummary {...{ emailShown, setEmailShown, query }}/>
                    </div>
                </div>
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(SecureInbox);